"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = __importDefault(require("../Config"));
const Logger_1 = require("../../utils/Logger");
const MetaValidator_1 = __importDefault(require("../../utils/MetaValidator"));
const paramsValidator = MetaValidator_1.default.create().bool('strict', true).validator();
function OdinConfig(definition, params = {}) {
    if (Config_1.default.isInitialized()) {
        (0, Logger_1.error)('@OdinConfig can only be used once');
    }
    const validate = MetaValidator_1.default.validateDecorator(OdinConfig, paramsValidator, definition, params);
    if (validate) {
        return validate;
    }
    if (Object.prototype.hasOwnProperty.call(params, 'strict')) {
        Config_1.default.setStrict(params.strict);
    }
    Config_1.default.setInitialized(true);
    return definition;
}
exports.default = OdinConfig;
//# sourceMappingURL=OdinConfig.js.map